class FilterDropdown {
    constructor(element) {
        this.element = element;

        this.select = this.element.querySelector('select');
        this.form = this.element.querySelector('form');
        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.select.addEventListener('change', () => this.form.submit());
    }
}

export default FilterDropdown;
